import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as prelaunchService from "../../services/prelaunch.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDateWithMonth, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder} from "rsuite";



const PrelaunchView = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: "Prelaunch Inquiries",
      url: "/admin/prelaunch/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    prelaunchService
      .Details(params.id)
      .then((response) => {
        console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  VIEW INQUIRY
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>First Name</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.firstName
                              ? showdefault.firstName
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Last Name</th>
                          <td>
                            {showdefault && showdefault.lastName
                              ? showdefault.lastName
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>

                       
                        <tr>
                          <th>Here For?</th>
                          <td>
                            {showdefault && showdefault.hereFor
                              ? showdefault.hereFor
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_message")}</th>
                          <td>
                            {showdefault && showdefault.message
                              ? showdefault.message
                              : "N/A"}
                          </td>
                        </tr>


                        <tr>
                          <th>{t("label_inquiry_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDateWithMonth(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault && showdefault.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr> */}
                      
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/prelaunch/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrelaunchView;
